
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/error/unknown",
      function () {
        return require("private-next-pages/error/unknown.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/error/unknown"])
      });
    }
  